import { render, staticRenderFns } from "./ResetPasswordSend.vue?vue&type=template&id=6e55febc&scoped=true"
import script from "./ResetPasswordSend.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordSend.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordSend.vue?vue&type=style&index=0&id=6e55febc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55febc",
  null
  
)

export default component.exports